import React from 'react'
import { observer } from 'mobx-react'
import { useEnvValue, useWillPipe } from '@morningtrain/react-helpers'
import { useModel } from '@morningtrain/react-resources'

function OrderItemsToEnvOnPipe (props) {
  const model = useModel()
  const [envItems, setEnvItems] = useEnvValue('globals.inventory.order_items')

  useWillPipe((payload) => {
    return new Promise((resolve, reject) => {
      const items = model.get('order_items')

      const transformedItems = {}

      if (items && items.length > 0) {
        items.forEach((itemEntry) => {
          transformedItems[itemEntry.inventory_item_id] = {
            holdings: itemEntry.holdings,
            price: itemEntry.price,
            suggestion: itemEntry.suggestion,
            total: itemEntry.total,
            total_price: itemEntry.total_price,
            norm: itemEntry.norm,
            adjustment: itemEntry.adjustment,
            received: itemEntry.received,
            received_offset: itemEntry.received_offset,
            received_offset_price: itemEntry.received_offset_price,
            received_price: itemEntry.received_price,
            total_amount: (itemEntry.item) ? itemEntry.total * itemEntry.item.amount_per_unit : 0,
            office_should_handle: itemEntry.office_should_handle || false,
            who_should_handle_offset: itemEntry.who_should_handle_offset || null
          }
        })
      }

      setEnvItems(transformedItems)

      resolve(payload)
    })
  }, [model])

  return null
}

export default observer(OrderItemsToEnvOnPipe)
